import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";

function LeadSourceList() {
  const user = JSON.parse(localStorage.getItem("user"));
  const leadSourcePermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 8 && access.label_value != 0
  );

  const { searchData } = useContext(DataContext);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [leadSourceButton, setLeadSourceButton] = useState("");
  const [leadSourceData, setLeadSourceData] = useState([]);
  const [editLeadSource, setEditLeadSource] = useState("");
  const [errors, setErrors] = useState("");
  const [paginationLeadSourceData, setPaginationLeadSourceData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [leadSource, setLeadSource] = useState({
    name: "",
  });

  const fetchLeadSource = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const apiUrl = searchData
        ? `public/api/admin/leadsource/pagination?page=${page}&search=${searchData}`
        : `public/api/admin/leadsource/pagination?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      setLeadSourceData(response.data.LeadSource.data);
      setPaginationLeadSourceData(response.data.LeadSource); // Add pagination handling if needed
    } catch (error) {
      console.error("Error fetching lead sources:", error);
    }
  };

  useEffect(() => {
    fetchLeadSource(currentPage);
  }, [searchData, currentPage]);

  const handleAddLeadSource = () => {
    setLeadSourceButton("save");
    setLeadSource({ leadSource: "" });
    setIsDialogOpen(true);
  };

  const handleChangeForLeadSource = (e) => {
    setLeadSource({
      ...leadSource,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveLeadSource = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        "public/api/admin/leadsource/store",
        leadSource,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );



      if (response.data) {
        setIsDialogOpen(false);
        setErrors();
        toast.success("leadSource type added successfully");
        fetchLeadSource();
      } else if (response.data.success === false) {
        setErrors(response.data.data.leadSource);
      } else {
        toast.error("Failed to add leadSource type");
      }
    } catch (error) {
      console.error("Error adding leadSource type:", error);
    }
  };

  const handleEditLeadSource = async (id_crypt) => {

    setIsDialogOpen(true);

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(
        `public/api/admin/leadsource/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

  

      const leadSourceData = response.data.Lead_Source;

      // Correctly setting the state
      setLeadSource({ name: leadSourceData.name });

      setEditLeadSource(id_crypt);
      setLeadSourceButton("update");
      setIsDialogOpen(true);
    } catch (error) {
      console.error("Error fetching leadSource:", error);
      // toast.error("Failed to fetch lead source for editing");
    }
  };

  const handleUpdateLeadSource = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    setLeadSourceButton("update");

    try {
      const response = await axios.put(
        `public/api/admin/leadsource/update/${editLeadSource}`,
        leadSource,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.data) {
        setIsDialogOpen(false);
        toast.success("leadSource type updated successfully");
        fetchLeadSource();
      } else {
        toast.error("Failed to update leadSource type");
      }
    } catch (error) {
      console.error(
        "Error updating leadSource type:",
        error.response ? error.response.data : error
      );
      // toast.error("Failed to update leadSource type");
    }
  };

  const handlePageChange = async (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);

      setCurrentPage(newPage);
      await fetchLeadSource(newPage);
    }
  };

  return (
    <>
      <HeaderWithButton
        title="Lead Source"
        description="lead source"
        buttonText="Lead Source"
        onButtonClick={handleAddLeadSource}
        showButton={leadSourcePermission}
      />

      <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
        <div className="mt-6 overflow-hidden rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
              <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  S No
                </th>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  Lead Source
                </th>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 ">
              {paginationLeadSourceData?.data?.map((leadSource, index) => (
                <tr key={index}>
                   <td className="px-6 py-4 whitespace-nowrap text-center text-sm  font-medium">
                    {paginationLeadSourceData.from + index}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500 uppercase">
                    {leadSource.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                    {leadSourcePermission && (
                      <button
                        className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                        onClick={() =>
                          handleEditLeadSource(leadSource.id_crypt)
                        }
                      >
                        <PencilSquareIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-edit"
                          place="top"
                          className="text-xs p-0"
                          style={{
                            fontSize: "12px",
                            padding: "0.3rem",
                          }}
                        >
                          Edit
                        </Tooltip>
                      </button>
                    )}

                    {leadSourcePermission && (
                      <DeleteConfirmation
                        id_crypt={leadSource.id_crypt}
                        apiType={"leadSource"}
                        fetchClientData={fetchLeadSource}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {isDialogOpen && (
          <Dialog
            open={isDialogOpen}
            onClose={() => {}}
            className="relative z-10"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                  <div
                    className="flex justify-between items-center mb-4 p-4"
                    style={{ backgroundColor: "#6366f1" }}
                  >
                    <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                      Lead Source
                    </h1>
                    <button
                      type="button"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XMarkIcon
                        className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div className="sm:col-span-2">
                        <form>
                          <div className="overflow-hidden sm:rounded-md">
                            <div className="space-y-4">
                              <div>
                                <label
                                  htmlFor="leadSource"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Name
                                </label>
                                <div className="mt-2">
                                  <input
                                    name="name"
                                    type="text"
                                    value={leadSource.name}
                                    onChange={handleChangeForLeadSource}
                                    autoComplete="mode"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                {errors && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {errors}
                                  </p>
                                )}
                              </div>

                              <div className="flex  space-x-2">
                                {leadSourceButton === "save" ? (
                                  <button
                                    onClick={handleSaveLeadSource}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleUpdateLeadSource}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => setIsDialogOpen(false)}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        )}
      </div>

      {paginationLeadSourceData && (
        <Pagination
          links={paginationLeadSourceData.links}
          currentPage={paginationLeadSourceData.current_page}
          totalResults={paginationLeadSourceData.total}
          from={paginationLeadSourceData.from}
          to={paginationLeadSourceData.to}
          lastPage={paginationLeadSourceData.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}

export default LeadSourceList;
